<template lang="pug">
  .search-bar
    .search-label(v-if="showLabel")
      label(:for="uniqueId") Search
    .search-input(:class="{'glow': glow}")
      .search-icon
        img(src="../assets/img/magnifying_glass.png")
      input.search-control.form-control(:id="uniqueId",type="text",@focus="glow = true",@focusout="glow = false",@input="emit",:value="value",ref="search")
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    value: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      glow: false,
    }
  },
  methods: {
    emit: function() {
      this.$emit('input', this.$refs.search.value)
    },
  },
  computed: {
    uniqueId: function() {
      return `searchbar-${this._uid}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';

.search-input {
  display: flex;
  border: 1px solid #e6e6e6;
  background-color: white;
}

.search-input.glow {
  outline: 3px solid rgba($primary, 0.3);
  border: 1px solid rgba($primary, 0.8);
  transition: outline 0.05s ease;
}

.search-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: inherit;
  margin-left: 5px;
  img {
    width: 1.2rem;
    height: 1.2rem;
  }
}

.search-control {
  border: none;
  outline: none;
}

.search-control:focus {
  box-shadow: none;
  border: none;
  outline: none;
}
</style>
